import type { FC } from 'react';
import { HiSortAscending, HiSortDescending } from 'react-icons/hi';
import { IconButton, useTheme } from '@mui/material';

interface ButtonSortBy {
  sortKey: string;
  sortBy: string | null;
  onClickCallback: () => void;
}

const ButtonSortBy: FC<ButtonSortBy> = ({
  sortKey,
  sortBy,
  onClickCallback,
}) => {
  const theme = useTheme();

  return (
    <IconButton
      aria-label={`${sortKey}-sort-button`}
      onClick={onClickCallback}
      disableRipple
    >
      {sortBy === `-${sortKey}` ? (
        <HiSortDescending size={16} color={theme.colors.primary[600]} />
      ) : (
        <HiSortAscending
          size={16}
          color={sortBy === sortKey ? theme.colors.primary[600] : 'inherit'}
        />
      )}
    </IconButton>
  );
};

export default ButtonSortBy;
